import { IDropDown } from 'src/app/shared/utils/iui-list-item';



  export class Account {
    FirstName: string;
    LastName: string;
    UserName: string;
    id: string;
    Role: string[]
    exp: number;
    iss: string;
    aud: string;
    token:string
}

export type UserTypes ='public'|'private'|'';

export interface IUserProfile {
  token: string;
  userName: string;
  validatUntill: Date;
  refreshToken: string;
  userId: number;
  coreUserId: string;
  guidId: string;
  sessionId: string;
  role: string;
  fullName: string;
  clinicName: string;
  clinicId: number;
  clinics: IDropDown[];
  twoFactorAuthentication: boolean;
  forcePasswordChange: boolean;
  passwordExpired: boolean;
  chooseClinic: boolean;
  isADUser: boolean;
  userType:UserTypes
}


export interface UserProfile {
  userProfile:UserProfileDetails,
  loaded:boolean
}


export class UserProfileDetails {
  userName: string;
  userId: number;
  coreUserId: number;
  userRole: string;
  fullName: string;
  clinicName: string;
  clinicId: number;
}


export type Roles = 'Provider' | 'Doctor';

export type TokenTypes = 'AccessToken'

export interface IPassRecovery {
  userName: string;
}
export interface ITempPassChange {
  userName: string;
}
export interface IUserPassChange {
  userName: string;
}


export enum ResponseStatus {
  Success
}